

























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { RimRepairLayoutComponent } from "@/components/common";
import { ICustomer, ICustomerResponseData } from "@/interfaces";
import { SearchCustomers } from "@/api";
import { DataTableHeader } from "vuetify";
import { HELPER } from "@/utils/Helper";
import { Getter } from "vuex-class";

@Component({
  components: {
    RimRepairLayoutComponent
  }
})
export default class CustomersListComponent extends Vue {
  public search = "";
  public page = 0;
  public size = 5;
  public total = 0;
	public activeOnly: boolean = true;
  public customers: ICustomer[] = [];
  public debounce!: number;
  public headers: DataTableHeader[] = [
    {
      text: "Full name",
      value: "Billing.CustomerName"
    },
    {
      text: "Company",
      value: "Billing.Company"
    },
    {
      text: "Email",
      value: "Billing.Email"
    },
    { text: "", value: "edit", sortable: false },
    { text: "", value: "add", sortable: false }
  ];
  public loading = false;
  public addCustomerRoute = "/office/customers/add";


  @Getter("getTimestampCustomers", { namespace: "AppModule" })
  private getTimestampCustomers: string;

  @Watch("getTimestampCustomers")
  onValueChanged(newVal: any, oldVal: any) {
		/// WE ARE WATCHING A VUEX VARIABLE THAT TELLS 
		/// IF THE USERS CHANGED, IN WHICH CASE WE SHOULD
		/// TRIGGER A NEW SEARCH.
		this.searchCustomers();
	}


  mounted() {
		this.RestoreSearch();
    this.searchCustomers();
  }

	private PreserveSearch():void{
		HELPER.Preserve("customers-search",  {
			search: this.search,
			size: this.size,
			ao: this.activeOnly,
		})
	}

	private RestoreSearch():void{
		var o = HELPER.Restore("customers-search");
		if (o==null)return;
		this.search = o.search;
		this.size = o.size;
		this.activeOnly = o.ao;
	}


  async searchCustomers() {
		this.PreserveSearch();
    try {
      this.loading = true;
      const page = this.page - 1 > 0 ? this.page - 1 : 0;
			var isActive = this.activeOnly ? true: null;
      const resp = await SearchCustomers(this.search, page, this.size, isActive);
      if (resp.Ok) {
        this.customers = resp.Results.Customers;
        this.setPagination(resp.Results);
      }
      this.loading = false;
    } catch (err) {
      //
    }
  }

  setPagination(data: ICustomerResponseData) {
    this.page = data.Page! + 1;
    // this.size = data.PageSize!;
    this.total = data.TotalRecords;
  }

  changePagination(page: number) {
    this.page = page;
    this.searchCustomers();
  }

  get pages() {
    return Math.ceil(this.total / this.size);
  }

  searchFn() {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(() => {
      this.page = 0;
      // this.size = 5;
      this.searchCustomers();
    }, 500);
  }

  goTo(path: string): void {
    if (this.$route.path !== path) this.$router.push(path);
  }

  editCustomer(customer: ICustomer): void {
    this.$router.push({
      path: `/office/customers/edit/${customer.RecordID}`
    });
  }

  addWorkOrder(customer: ICustomer) {
    this.$router.push({
      path: `/office/work-order/add/${customer.RecordID}`
    });
  }
}


